import { h } from 'vue';
import { RouteRecordRaw, RouterView } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/appuntamenti',
            meta: {
                showNavbar: true
            },
            component: { render: () => h(RouterView) },
            children: [
                { 
                    path: '',
                    name: 'appuntamenti',
                    component: () => import("./appuntamenti.vue")
                },
                { 
                    path: ':identifier',
                    name: 'appuntamentiDetail',
                    meta: {
                        showNavbar: false
                    },
                    component: () => import("./appuntamentiDetail.vue")
                },
                { 
                    path: ':identifier/modifica',
                    name: 'appuntamentiDetailModifica',
                    meta: {
                        showNavbar: false
                    },
                    component: () => import("./appuntamentiDetailModifica.vue")
                }
            ]
        },
    ];
};